import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{staticStyle:{"max-width":"500px"},attrs:{"fill-height":""}},[_c(VLayout,{attrs:{"row":"","wrap":"","align-center":""}},[_c(VFlex,{staticClass:"text-xs-center"},[_c(VCard,[_c(VCardText,[_c('div',{staticClass:"display-1"},[_vm._v("\n            Logging out...\n          ")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }